import { useCallback } from 'react';
import useWfApi from './axios/useWfApi';
import {
  WFAlertHistoryDetailsResponse,
  WFAlertHistorySearchResponse,
} from '../models/WfAlertHistory';

function useWfAlertHistoryRepo() {
  const { get } = useWfApi();

  const getAlertHistorySearchRequest = useCallback(
    async (params: { disasterId?: string; customerNumber?: string; branchCode?: string }) => {
      try {
        const query = {
          ...(params.disasterId ? { disasterId: params.disasterId } : {}),
          ...(params.customerNumber ? { customerNumber: params.customerNumber } : {}),
          ...(params.branchCode ? { branchCode: params.branchCode } : {}),
        };
        const response = await get<WFAlertHistorySearchResponse>('/api/wf/alerts/history/search', {
          params: query,
        });
        return response?.alertHistory ?? null;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    [get]
  );
  const getAlertHistoryDetailsRequest = useCallback(
    async (params: {
      disasterId?: string;
      buildingCode?: string;
      customerNumber?: string;
      branchCode?: string;
      propertyName1?: string | undefined;
      propertyName2?: string | undefined;
      propertyName3?: string | undefined;
      propertyName4?: string | undefined;
    }) => {
      try {
        const query = {
          ...(params.disasterId ? { disasterId: params.disasterId } : {}),
          ...(params.buildingCode ? { buildingCode: params.buildingCode } : {}),
          ...(params.customerNumber ? { customerNumber: params.customerNumber } : {}),
          ...(params.branchCode ? { branchCode: params.branchCode } : {}),
          ...(params.propertyName1 ? { propertyName1: params.propertyName1 } : {}),
          ...(params.propertyName2 ? { propertyName2: params.propertyName2 } : {}),
          ...(params.propertyName3 ? { propertyName3: params.propertyName3 } : {}),
          ...(params.propertyName4 ? { propertyName4: params.propertyName4 } : {}),
        };
        const response = await get<WFAlertHistoryDetailsResponse>(
          '/api/wf/alerts/history/search/details',
          {
            params: query,
          }
        );
        return response?.alertHistoryDetail ?? [];
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    [get]
  );

  return { getAlertHistorySearchRequest, getAlertHistoryDetailsRequest };
}

export default useWfAlertHistoryRepo;
